module.exports = jWeixin;


//////////////////
// WEBPACK FOOTER
// external "jWeixin"
// module id = ebTe
// module chunks = 1